export function normalizeSearchText(raw) {
    return raw
        .toLocaleLowerCase('ru')
        .replace(/ё/g, 'е')
        .replace(/\s+/g, ' ')
        .trim();
}
export function searchTokens(query) {
    const normalized = normalizeSearchText(query);
    if (!normalized)
        return [];
    return normalized.split(' ').filter(Boolean);
}
export function engagementSearchHaystack(card) {
    const parts = [card.agentDisplayName, card.agencyName ?? ''];
    const metrics = card.metrics;
    if (metrics) {
        for (const value of Object.values(metrics)) {
            if (value == null || value === '')
                continue;
            parts.push(String(value));
        }
    }
    return normalizeSearchText(parts.join(' '));
}
export function matchesEngagementSearch(card, query) {
    const tokens = searchTokens(query);
    if (tokens.length === 0)
        return true;
    const haystack = engagementSearchHaystack(card);
    return tokens.every((token) => haystack.includes(token));
}
export function filterEngagementRows(rows, query) {
    const tokens = searchTokens(query);
    if (tokens.length === 0)
        return rows;
    return rows.filter((card) => matchesEngagementSearch(card, query));
}
